<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  .skeleton-wrapper {
    display: flex;
    flex-direction: column;
    gap: utils.in_rem(24px);
    height: 100%;
    overflow: auto;
    padding-top: utils.in_rem(16px);
    width: 100%;

    .skeleton-section {
      display: flex;
      flex-direction: column;
      gap: utils.in_rem(12px);
      width: 100%;

      .skeleton-header {
        @include colors.background-color(interfaceSwGrey_5);
        border-radius: utils.in_rem(4px);
        height: utils.in_rem(16px);
        margin-left: utils.in_rem(17px);
        width: utils.in_rem(120px);

        &.skeleton {
          @include mixins.skeleton();
        }
      }

      .skeleton-items {
        display: flex;
        flex-direction: column;
        gap: utils.in_rem(20px);
        width: 100%;

        .skeleton-item {
          display: flex;
          flex-direction: column;
          gap: utils.in_rem(6px);
          padding-left: utils.in_rem(17px);

          .skeleton-title-row {
            display: flex;
            gap: utils.in_rem(8px);

            .skeleton-role {
              @include colors.background-color(interfaceSwGrey_5);
              border-radius: utils.in_rem(4px);
              height: utils.in_rem(16px);
              width: utils.in_rem(180px);

              &.skeleton {
                @include mixins.skeleton();
              }
            }

            .skeleton-duration {
              @include colors.background-color(interfaceSwGrey_5);
              border-radius: utils.in_rem(4px);
              height: utils.in_rem(16px);
              width: utils.in_rem(100px);

              &.skeleton {
                @include mixins.skeleton();
              }
            }
          }

          .skeleton-company {
            @include colors.background-color(interfaceSwGrey_5);
            border-radius: utils.in_rem(4px);
            height: utils.in_rem(14px);
            width: utils.in_rem(150px);

            &.skeleton {
              @include mixins.skeleton();
            }
          }

          .skeleton-description {
            @include colors.background-color(interfaceSwGrey_5);
            border-radius: utils.in_rem(4px);
            height: utils.in_rem(12px);
            width: 90%;

            &.skeleton {
              @include mixins.skeleton();
            }
          }
        }
      }
    }
  }
</style>

<div class="skeleton-wrapper">
  <div class="skeleton-section">
    <div class="skeleton-header skeleton"></div>
    <div class="skeleton-items">
      {#each Array(3) as _}
        <div class="skeleton-item">
          <div class="skeleton-title-row">
            <div class="skeleton-role skeleton"></div>
            <div class="skeleton-duration skeleton"></div>
          </div>
          <div class="skeleton-company skeleton"></div>
          <div class="skeleton-description skeleton"></div>
        </div>
      {/each}
    </div>
  </div>

  <div class="skeleton-section">
    <div class="skeleton-header skeleton"></div>
    <div class="skeleton-items">
      {#each Array(2) as _}
        <div class="skeleton-item">
          <div class="skeleton-title-row">
            <div class="skeleton-role skeleton"></div>
            <div class="skeleton-duration skeleton"></div>
          </div>
          <div class="skeleton-company skeleton"></div>
        </div>
      {/each}
    </div>
  </div>
</div>
